import './index.scss';
import { DropdownButton } from 'ii-react-sdk/form_components';
import React from 'react';
import { useLocalStorage } from 'react-use';
import { useAuth } from '~/providers/auth';
import { useUser } from '~/providers/user';
const CogMenu = () => {
    const [isDebugLogging, setIsDebugLogging] = useLocalStorage('debug-logging');
    const { signOut } = useAuth();
    const { email } = useUser();
    const titleIcon = React.createElement("span", { className: 'fas fa-cog cog-btn menu-icon' });
    const leftClickOptions = React.createElement(React.Fragment, null,
        React.createElement("div", { onClick: signOut },
            React.createElement("span", { className: 'fas fa-fg fa-sign-out-alt cog-btn-dark' }),
            "Sign out"));
    const rightClickOptions = React.createElement(React.Fragment, null, email.endsWith('@boldpenguin.com') && React.createElement(React.Fragment, null,
        React.createElement("div", { onClick: () => setIsDebugLogging(!isDebugLogging) },
            "Turn ",
            isDebugLogging ? 'OFF' : 'ON',
            " Debug Mode")));
    return React.createElement(DropdownButton, { className: 'general-settings-cog-btn', mainText: titleIcon, plain: true, hideArrow: true, rightClickChildren: React.createElement(React.Fragment, null,
            leftClickOptions,
            rightClickOptions) }, leftClickOptions);
};
export default CogMenu;
